import { Box, Checkbox, Stack } from '@mui/material';
import type { BackupPolicy } from '@repo/api-gw-sdk';

import BackupPolicyTag from '@/components/backupPolicy/BackupPolicyTag';

export const BackupPoliciesSelector = (props: {
  backupPolicies: BackupPolicy[];
  selectedPolicies: BackupPolicy[];
  setSelectedPolicies: (policies: BackupPolicy[]) => void;
}) => {
  const { backupPolicies, selectedPolicies, setSelectedPolicies } = props;

  return (
    <Box
      className='px-[40px]'
      sx={{
        maxHeight: '300px',
        overflow: 'auto',
      }}
    >
      {backupPolicies.map((policy) => (
        <Stack
          direction='row'
          alignItems='center'
          key={policy.id}
          gap='8px'
          sx={{ py: '4px' }}
        >
          <Checkbox
            value={policy.id}
            checked={selectedPolicies.some((p) => p.id === policy.id)}
            onChange={(e) => {
              if (e.target.checked) {
                setSelectedPolicies([...selectedPolicies, policy]);
              } else {
                setSelectedPolicies(
                  selectedPolicies.filter((p) => p.id !== policy.id)
                );
              }
            }}
          />
          <BackupPolicyTag policy={policy} />
        </Stack>
      ))}
    </Box>
  );
};
